import React, { useEffect } from 'react'

import Warning from 'assets/svg/warning.svg'

import Button from '../../../../components/Button'
import Modal from '../../../../components/Modal'

import './ModalMaintenanceProduct.scss'
import { TagPushProposal } from '../../../../analytics/proposal'

const ModalMaintenanceProduct = (props) => {
    useEffect(() => {
        TagPushProposal.screenViewHasProduct(
            props.bank.name,
            props.cart.spokesman.documentNumber,
            props.cart.company.document
        )
    }, [])

    return (
        <Modal open={props.open} onClick={props.onClick} closeBtn={true}>
            <div className="maintenance-product__body">
                <img
                    className="maintenance-product__icon"
                    src={Warning}
                    alt="icon"
                />
                <div style={{ height: '19px' }} />
                <span className="maintenance-product__body--title">OPS!</span>
                <div style={{ height: '19px' }} />
                <span className="maintenance-product__body--title">
                    A sua empresa já tem esse produto com a gente.
                </span>
                <div style={{ height: '19px' }} />
                <span className="maintenance-product__body--description">
                    <strong>
                        Você quer fazer uma carga nos cartões ou pedir cartões
                        para outros colaboradores?
                    </strong>
                </span>
                <span className="maintenance-product__body--description">
                    É só acessar o sistema de pedidos e clicar em &quot;Fazer
                    novo pedido”.
                </span>
                <Button
                    style={{ width: '216px' }}
                    gtmCategory="alelo:loja-virtual"
                    gtmAction="clique:erro"
                    gtmLabel="ir-para-sistema-de-pedidos"
                    onClick={() =>
                        window.location.assign('https://pedidos.alelo.com.br/')
                    }
                    type="button"
                    kind="add"
                >
                    ir para sistema de pedidos
                </Button>
                <Button
                    id="requestOtherProductBtn"
                    style={{ width: '189px' }}
                    gtmCategory="alelo:loja-virtual"
                    gtmAction="clique:erro"
                    gtmLabel="pedir-outro-cartao"
                    onClick={props.onClick}
                    type="button"
                    kind="outlined"
                >
                    Pedir outro produto
                </Button>
                <br />
            </div>
        </Modal>
    )
}

export default ModalMaintenanceProduct
